import { render } from "./GrowthOverview.vue?vue&type=template&id=ac2f58de&scoped=true"
import script from "./GrowthOverview.vue?vue&type=script&lang=js"
export * from "./GrowthOverview.vue?vue&type=script&lang=js"

import "./GrowthOverview.vue?vue&type=style&index=0&id=ac2f58de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac2f58de"]])

export default __exports__